module.exports = __webpack_public_path__ + "static/img/bar.f925d0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/tabbar/bar.png
// module id = kWVP
// module chunks = 24